import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '@commons';
import { GenericResponse } from '@interfaces';
import { BehaviorSubject, Observable, of } from 'rxjs';

export interface BreadCrumb {
  label: Observable<string>;
  url: string;
}

export interface IHeaderNamesService {
  getBreadCrumb(): Observable<string>;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public breadcrumbs$: BehaviorSubject<BreadCrumb[]> = new BehaviorSubject<BreadCrumb[]>(null);
  private notification: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private injector: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private config: ConfigService
  ) {
    this.injector = {};
  }

  refresh(routeData) {
    this.breadcrumbs$.next(this.buildBreadCrumb(routeData));
  }

  private buildBreadCrumb(routeData, breadcrumbs: BreadCrumb[] = []): BreadCrumb[] {
    const url = this.router.config.find(r => r.data && r.data.id === routeData.id);
    const breadcrumb = { url: !breadcrumbs.length ? '' : url.path, label: this.transformName(routeData.title) };

    const newBreadcrumbs = [breadcrumb, ...breadcrumbs];
    if (routeData && routeData.parent) {
      const routeParent = this.router.config.find(r => r.data && r.data.id === routeData.parent);
      return this.buildBreadCrumb(routeParent.data, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }

  private transformName(name: string): Observable<string> {
    if (typeof name === 'string' && name.startsWith('::')) {
      const serviceName = name.replace('::', '');
      const service: IHeaderNamesService = this.injector[serviceName];
      return service.getBreadCrumb();
    } else {
      return of(name);
    }
  }

  public getContractsPending(url: string): Observable<GenericResponse> {
    return this.http.get<GenericResponse>(this.config.getUrl(url));
  }

  public setNotification(data: boolean): void {
    this.notification.next(data);
  }

  public getNotification(): BehaviorSubject<boolean> {
    return this.notification;
  }

  public notificationsMarkAsViewed(url: string): Observable<GenericResponse> {
    return this.http.get<GenericResponse>(this.config.getUrl(url));
  }

  public downloadFile(id: number): Observable<any> {
    return this.http.get(this.config.getUrl('contrato.headerDownloadFile', { idFichero: id }), {
      headers: { Accept: 'application/pdf' },
      responseType: 'blob',
      observe: 'response'
    });
  }
}
